module.exports = __webpack_public_path__ + "fonts/IQOS-Light.65f89a2.ttf";